import Axios from "axios";

export const SelectAllEcheanceFRS = ( a, b, c, d, e) => {
  return (dispatch) => {
    const today = new Date();
    today.setFullYear(today.getFullYear() + 20);
    
    const datePlus2Ans = today.toISOString().slice(0, 10);
    Axios.get("https://www.24-crm.tn/webservice/api/Echeancefrs", {
        params: {
          frsdeb: "+",
          frsfin: "+",
          datdeb: "2000-01-14",
          datfin: datePlus2Ans,
          ModReg: "%",
          Banque: "%",
          Categ: "%",
          Region: "%",
          Situation: "%",
          CodCCB: "%",
          coddos: a,
          serveur: b,
          user: c,
          pwd: d,
          database: e,
        },
      }).then((response) => {
        dispatch({ type: "Echfrs_GET", payload: response.data });
      });
      
  };
};



